import {CalEvent} from "../utils/model/CalEvent";
import {CalAttendee} from "../utils/model/CalAttendee";
import {HtmlUtils} from "inet-core";
import {CalendarUtils} from "../CalendarUtils";
declare let iNet: any;

export class CalendarEvent {
    subject?: string;
    summary?: string;
    repeatText: string = '';
    timeDisplay: string = '';
    event: CalEvent;
    myAttendee?: CalAttendee;

    constructor(event: CalEvent) {
        this.event = event;
        if(!event) {
          return;
        }
        this.subject = event.subject ? HtmlUtils.formatHtmlDisplay(event.subject): '';
        this.summary = event.summary ? HtmlUtils.formatHtmlDisplay(event.summary): '';
        if(event.members) {
            this.myAttendee = event.members.find(item => {
                return item.role !== 'CREATOR' && item.username === iNet.username;
            });
        }
        if (event.repeat) {
            this.repeatText = CalendarUtils.getRepeatText(event.repeat);
        } else {
            this.repeatText = '';
        }
        this.timeDisplay = CalendarUtils.displayDay(event.start);
        if (event.attribute._allday !== 'true') {
            this.timeDisplay += ` ⋅ ${CalendarUtils.displayTime(event.start)} - ${CalendarUtils.displayTime(event.end)}`;
        }
    }
}
